import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from 'hooks/useAuth'

const AdminRoute = () => {
  const { isAdmin, isLoading } = useAuth()

  if (isLoading) return null // Hoặc spinner

  if (!isAdmin) {
    window.location.href = '/401'
  }

  return <Outlet />
}

export default AdminRoute
